const prefix = 'fasr';
const iconName = 'database';
const width = 448;
const height = 512;
const aliases = [];
const unicode = 'f1c0';
const svgPathData = 'M48 206v50 21.4L141.8 336H306.2L400 277.4V256 206l-80 50H128L48 206zM0 176V128 80L128 0H320L448 80v48 48 80 48V432L320 512H128L0 432V304 256 176zm400-48V106.6L306.2 48H141.8L48 106.6V128v21.4L141.8 208H306.2L400 149.4V128zM48 405.4L141.8 464H306.2L400 405.4V334l-80 50H128L48 334v71.4z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
